export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#141414] px-6 sm:px-10 md:px-16 py-10"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <p className="kv-overline text-[#6b6b6b]">
          © {year} · Kachevsky · All recordings reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
